import { PRESUPUESTADOR_ENDPOINT } from 'cfgCommon/endpoints'
import axios from 'axios'

export const sendEmailPdf = async (id, email) => {
    const response = await axios(`${PRESUPUESTADOR_ENDPOINT}/${id}/mail?email=${email}`)
    return response;
}
